import { useCallback, useLayoutEffect, useRef } from "react";

/**
 * Keeps the chat message list pinned to the bottom when auto-scroll is enabled.
 * Scroll is owned by the parent container — not individual message bubbles.
 */
export default function useChatAutoScroll({
  enabled,
  messages,
  conversationId,
}) {
  const scrollContainerRef = useRef(null);

  const scrollToBottom = useCallback((behavior = "auto") => {
    const el = scrollContainerRef.current;
    if (!el) return;
    el.scrollTo({ top: el.scrollHeight, behavior });
  }, []);

  useLayoutEffect(() => {
    if (!enabled || !conversationId) return;

    scrollToBottom("auto");
    const frameId = requestAnimationFrame(() => scrollToBottom("auto"));

    return () => cancelAnimationFrame(frameId);
  }, [messages, conversationId, enabled, scrollToBottom]);

  return { scrollContainerRef, scrollToBottom };
}
